export const inert = (enable: boolean) => (enable ? { inert: '' } : {});
